module.exports = "/_next/static/images/bt-927ecffd501a46bd5bb3fe7cb8ef08e7.svg";